<template>
    <div>
        <div class="device-box d100-bg">
            <h3 class="device-name reveal-bottom">S200</h3>
            <p class="device-desc reveal-bottom">{{ $t("dv.st") }}</p>
            <img class="d100-img reveal-bottom" :src="device" alt="S200" />
        </div>
        <div
            class="device-box bg-fixed"
            :style="{
                backgroundImage: 'url(' + bg2 + ')',
            }"
        >
            <div class="wrap">
                <div class="device-title reveal-bottom">
                    {{ $t("dv.st1") }}<br />
                    {{ $t("dv.st2") }}
                </div>
                <div class="device-char">
                    <div
                        class="device-char-item reveal-bottom"
                        style="width:500px"
                    >
                        <img
                            :src="intro1"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:58px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">
                                {{ $t("dv.rd") }}
                            </h4>
                            <div class="device-chart-desc-cont">
                                256<span style="font-size:18px">MB</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="device-char-item reveal-bottom"
                        style="width:460px"
                    >
                        <img
                            :src="intro2"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:50px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">
                                {{ $t("dv.rd1") }}
                            </h4>
                            <div class="device-chart-desc-cont">
                                2<span style="font-size:18px">Mbps</span> -
                                20<span style="font-size:18px">Mbps</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="device-char-item reveal-bottom"
                        style="width:229px"
                    >
                        <img
                            :src="intro3"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:50px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">
                                {{ $t("dv.rd2") }}
                            </h4>
                            <div class="device-chart-desc-cont">
                                2<span style="font-size:18px">Gbps</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="device-char-item reveal-bottom"
                        style="width:500px"
                    >
                        <img
                            :src="intro4"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:50px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">
                                {{ $t("dv.rd3") }}
                            </h4>
                            <div class="device-chart-desc-cont">
                                220<span style="font-size:18px">mm * </span>
                                220<span style="font-size:18px">mm * </span>
                                35<span style="font-size:18px">mm</span>
                            </div>
                            <div class="device-chart-desc-detail"></div>
                        </div>
                    </div>
                    <div
                        class="device-char-item reveal-bottom"
                        style="width:460px"
                    >
                        <img
                            :src="intro5"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:50px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">CPU</h4>

                            <div class="device-chart-desc-detail">
                                MT7632A
                            </div>
                        </div>
                    </div>
                    <div
                        class="device-char-item reveal-bottom"
                        style="width:229px"
                    >
                        <img
                            :src="intro6"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:50px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">
                                {{ $t("dv.rd4") }}
                            </h4>

                            <div class="device-chart-desc-detail">
                                1000Mbps LAN x1<br />
                                1000Mbps WAN x1<br />
                                SIM/{{ $t("dv.sg") }} LTE x1
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="device-box">
            <div class="card-box reveal-bottom">
                <div class="card  d100">
                    <div class="card-head">
                        <div class="card-head-left">
                            <span>{{ $t("dv.ry") }}</span>
                            <div></div>
                        </div>
                        <div class="card-no">1</div>
                    </div>
                    <div
                        class="card-text"
                        :style="lang === 'en_US' ? 'font-size:25px' : ''"
                    >
                        {{ $t("dv.sy") }}<br />{{ $t("dv.sy1") }}
                    </div>
                </div>
                <div class="card  d100">
                    <div class="card-head">
                        <div class="card-head-left">
                            <span>{{ $t("dv.ru") }}</span>
                            <div></div>
                        </div>
                        <div class="card-no">2</div>
                    </div>
                    <div
                        class="card-text"
                        :style="lang === 'en_US' ? 'font-size:25px' : ''"
                    >
                        {{ $t("dv.suc") }}
                    </div>
                </div>
                <div class="card  d100">
                    <div class="card-head">
                        <div class="card-head-left">
                            <span>{{ $t("dv.ra") }}</span>
                            <div></div>
                        </div>
                        <div class="card-no">3</div>
                    </div>
                    <div
                        class="card-text"
                        :style="lang === 'en_US' ? 'font-size:25px' : ''"
                    >
                        {{ $t("dv.dac") }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import initAnimation from "../animation";
export default {
    name: "R200",
    data() {
        return {
            lang: localStorage.getItem("lang"),
            bg2: require("@/assets/images/devices/S200_bg.jpg"),
            device: require("@/assets/images/devices/S200_d.png"),
            intro1: require("@/assets/images/devices/R200_intro1.png"),
            intro2: require("@/assets/images/devices/R200_intro2.png"),
            intro3: require("@/assets/images/devices/R200_intro3.png"),
            intro4: require("@/assets/images/devices/R200_intro4.png"),
            intro5: require("@/assets/images/devices/R200_intro5.png"),
            intro6: require("@/assets/images/devices/R200_intro6.png"),
        };
    },
    mounted() {
        setTimeout(initAnimation, 0);
        this.$bus.$on("lang", (lang) => {
            this.lang = lang;
        });
    },
};
</script>
<style scoped>
@import "./devices.css";
.d100-img {
    display: block;
    height: 489px;
    width: 689px;
    margin: 53px auto 0;
}
.d100-bg {
    background: linear-gradient(left top, #d6acff, #a75fed);
}
.d100:hover {
    background-color: #a75fed;
    transition: all 0.3s ease;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Hardware/S200.vue